import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.tr0YPg',
    defaultMessage: 'Variables',
  },
  error: {
    id: 'studio.5KYXRU',
    defaultMessage: 'There was a problem loading the variables.',
  },
  loading: {
    id: 'studio.acLMip',
    defaultMessage: 'Loading variables…',
  },
  noVariables: {
    id: 'studio.52FEmm',
    defaultMessage: 'No variables have been configured yet.',
  },
  addNew: {
    id: 'studio.nVS/70',
    defaultMessage: 'Add new variable',
  },
});
